import React from "react";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { HSA_SEARCH_FORM_DESTINATION_ERROR, withTrackComponentDisplayed } from '../../utils/HtmlEvents';

export const DestinationError = withTrackComponentDisplayed(({ validationErrorKey }) => {
    const { t } = useTranslation();
    return (
        <span
            className="odf-label odf-text-sm odf-space-outer-xs"
            test-id="error-airport-selector"
        >
            {t(validationErrorKey)}
        </span>
    );
}, HSA_SEARCH_FORM_DESTINATION_ERROR);

DestinationError.propTypes = {
    validationErrorKey: PropTypes.string.isRequired,
}
